// IEshit issues
// import 'core-js';

import "../node_modules/@prokomssp/fantdu/dist/fantdu.min.js";
import { startMeUp } from "./scripts/startscript.js";
import { cookieRead, cookieDelete } from "./scripts/cookie_control";
import deepmerge from "./scripts/tools/deepMerge";

// Style
import './style/style.scss';

window.getUrlAttr = function(attr) {
    return new URL(window.location.href).searchParams.get(attr);
}

window.apiUrl = "https://prokom-aimcms.azurewebsites.net";
window.dev = false;

if (window.location.href.match(/\?dev/gi)) {
    window.apiUrl = "https://prokom-aimcms-qa.azurewebsites.net";
    window.dev = true;
}
if (cookieRead("RuntimeMode") === "local") {
	console.log("%c Entering RuntimeMode: Localhost ", "color: #004085; background-color: #cce5ff; font-size: 15px;");
	// window.cmsUrl = 'https://localhost:4200';
	window.dev = true;
}
if (cookieRead("RuntimeMode") == "dev")  {
    console.log("dev");
    window.apiUrl = "https://prokom-aimcms-dev.azurewebsites.net";
    window.dev = true;
}
if (cookieRead("RuntimeMode") == "qa") {
    console.log("qa");
    window.apiUrl = "https://prokom-aimcms-qa.azurewebsites.net";
    window.dev = true;
}
if (cookieRead("RuntimeMode") == "staging") {
    window.apiUrl = "https://prokom-aimcms-staging.azurewebsites.net";
    window.dev = true;
}
if (cookieRead("RuntimeMode") == "release") {
    window.apiUrl = "https://prokom-aimcms-release.azurewebsites.net";
    window.dev = true;
}
if (cookieRead("RuntimeMode") == "prod") {
    window.apiUrl = "https://prokom-aimcms.azurewebsites.net";
    window.dev = true;
}

window.contentID = "";
window.contentSubscription = "";

let host = window.location.host;

if (host.match("aim")) {
    if (host.split(".aim")) {
        let domain = host.split(".aim")[0];

        if (domain.match(/\./gi)) {
            domain = domain.split(".")[1];
        }

        sessionStorage.setItem("kommune", domain);
    }
}
if (host.match(".kommune.no")) {
    let domain = host.split(".kommune")[0];

    if (domain.match(/\./gi)) {
        domain = domain.split(".")[1];
    }

    sessionStorage.setItem("kommune", domain);
}
else if (host.match(/\./gi)) {
    let domain = host.split(".")[0];
    sessionStorage.setItem("kommune", domain);
}

window.urlify = (string) => {
    if (string !== null) {
        string = string.replace(/\s|\,|-/gi, "_").replace(/[æå]/gi, "a").replace(/[ø]/gi, "o").replace(/[_]{2,}/gi, "").toLowerCase();
    }
    return string;
}

window.getPageUrl = function() {
    let urldivert = location.pathname.substr(1).split(/\/(.+)/);
    let template = urldivert[0] || "frontpage";
    let contentid = urldivert[1] || "";

    return { template: template, contentid: contentid, path: urldivert };
}

if (document.referrer.match(/(https:\/\/aim-admin.azurewebsites.net)/gi)) {
    sessionStorage.setItem("fromcms", true);
}

window.translation = {}

document.addEventListener('DOMContentLoaded', function(e) {
    const data = { "clientDomainName": window.location.hostname };
    window.matchApplication = "1086ee5d-24b8-42bf-842f-5fe1dca688cf"; // kariadmin

    // console.log(data);

    let munic;
    const d = window.location.host;
    munic = d.replace(/\.aim\.prokom\.no|\.kommune\.no/gmi, "");
    if (munic.match(/localhost:\d{4}/gmi)) {
        // munic = "nordhordland";
        // sessionStorage.setItem("kommune", "nordhordland");
        munic = "nordhordlandbiosphere";
        sessionStorage.setItem("kommune", "nordhordlandbiosphere");
        // munic = "helsehus";
        // sessionStorage.setItem("kommune", "helsehus");
    }
    if(munic.split(".").length==2) 
        munic = munic.split(".")[0];
    else if (munic.match(/\./gmi))
        munic = munic.split(".")[munic.split(".").length - 1];
    else if (munic.match(/localhost:\d{3}/gmi)) {
        // munic = "nordhordland";
        // sessionStorage.setItem("kommune", "nordhordland");
        munic = "nordhordlandbiosphere";
        sessionStorage.setItem("kommune", "nordhordlandbiosphere");
        // munic = "helsehus";
        // sessionStorage.setItem("kommune", "helsehus");
    }

    // let initialPromise = [];
    // munic = munic.replace(/\-/gmi, "");

    // initialPromise.push(
    //     new Promise((resolve, reject) => {
    //         if(window.location.host.match(/localhost:\d{4}/gmi)) {
    //             // const data = { "clientDomainName": 'regionnordhordland.aim.prokom.no' };
    //             const data = { "clientDomainName": 'biosfaere.aim.prokom.no' };
    //             // const data = { "clientDomainName": 'helsehus.aim.prokom.no' };
    //             fetch('https://rolemanager.prokom.no/api/admin/organization/getclientbydomain', { 
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                 },
    //                 body: JSON.stringify(data),
    //             })
    //             .then(response => response.json())
    //             .then(data => {
    //                     if (data.result) {   
    //                         resolve(data);
    //                         // window.config = data.result;
    //                         // index();
    //                     }
    //             });
    //         }
    //         else {
    //             fetch("//config.aim.prokom.no/clients/configbackup/" + munic + ".aim.prokom.no.json", { headers: { "Content-Type": "application/json; charset=utf-8" } })
    //                 .then(response => response.json())
    //                 .then(data => {

    //                     if (data.result) {
    //                         resolve(data);
    //                     }
    //                 })
    //         }
    //     })
    // )

    // initialPromise.push(
    //     new Promise((resolve, reject) => {
    //         fetch("//config.aim.prokom.no/clients/configbackup/ummo.aim.prokom.no.json", { headers: { "Content-Type": "application/json; charset=utf-8" } })
    //             .then(response => response.json())
    //             .then(data => {
    //                 if (data.result) {
    //                     data.result.applications.forEach((appMeta) => {
    //                         // console.log(appMeta);
    //                         let meta;
    //                         if (appMeta.application.applicationServiceLocalId === "aim") {
    //                             meta = JSON.parse(decodeURIComponent(appMeta.metaData));
    //                         }
    //                         else if (appMeta.application.applicationServiceLocalId === "KariAdm") {
    //                             meta = JSON.parse(decodeURIComponent(appMeta.metaData));
    //                         }

    //                         resolve(meta.translation);
    //                     })
    //                 }
    //             })
    //     })
    // )

    // Promise.all(initialPromise).then(elm => {
    //     // console.log("all promises");
    //     const config = elm[0];
    //     let localTranslation = {};
    //     // console.log(localTranslation);
    //     config.result.applications.forEach((appMeta) => {
    //         // console.log(appMeta);
    //         let meta;

    //         if (appMeta.application.applicationServiceLocalId === "aim") {
    //             meta = JSON.parse(decodeURIComponent(appMeta.metaData));
    //         }
    //         else if (appMeta.application.applicationServiceLocalId === "KariAdm") {
    //             meta = JSON.parse(decodeURIComponent(appMeta.metaData));
    //         }

    //         if (meta.translation !== undefined) {
    //             // console.log("test", meta.translation);
    //             localTranslation = meta.translation;
    //         }

    //     })
    //     // console.log(localTranslation);
    //     let translation = elm[1];

    //     // console.log(localTranslation, translation);
    //     let joined = deepmerge(translation, localTranslation);

    //     // console.log(joined);
    //     window.translation = joined;

    //     console.log("starting site");
    //     startMeUp(config, e);
    // })

    if (window.serverdata !== undefined) {
		const meta = JSON.parse(window.serverdata.defaultConfig.result.applications[0].metaData);
		const defaultTranslation = meta.translation;
		const customTranslation = window.serverdata.configMeta.translation ? window.serverdata.configMeta.translation : {};
		window.translation = deepmerge(defaultTranslation, customTranslation);
		startMeUp(event);
	}
});
